import React from "react";
import { Box, Typography } from "@mui/material";

import { brand } from "../../themes/theme";

// Interpola color por intensidad (0-100) sobre el azul de marca: valores bajos
// casi blancos, altos en `primary` solido. Texto pasa a blanco a partir de ~55
// para mantener contraste.
function cellColor(value, max) {
    const t = Math.max(0, Math.min(1, value / (max || 100)));
    const from = { r: 237, g: 241, b: 250 }; // ice
    const to = hexToRgb(brand.primary);
    const r = Math.round(from.r + (to.r - from.r) * t);
    const g = Math.round(from.g + (to.g - from.g) * t);
    const b = Math.round(from.b + (to.b - from.b) * t);
    return { bg: `rgb(${r},${g},${b})`, text: t > 0.55 ? "#fff" : brand.navy };
}

function hexToRgb(hex) {
    const m = hex.replace("#", "");
    return {
        r: parseInt(m.substring(0, 2), 16),
        g: parseInt(m.substring(2, 4), 16),
        b: parseInt(m.substring(4, 6), 16),
    };
}

/**
 * Mapa de calor: filas x columnas, color por intensidad del valor (mismo
 * gradiente para toda la matriz, valores en la misma escala p.ej. %).
 *
 * @param {Array} rows - { label, values: [num, num, ...] } mismo orden que `columns`
 * @param {Array} columns - nombres de columna
 * @param {number} max - valor que corresponde al color mas intenso (por defecto 100)
 * @param {string} suffix - sufijo del valor mostrado en cada celda (p.ej. "%")
 */
function Heatmap({ rows, columns, max = 100, suffix = "%" }) {
    return (
        <Box sx={{ overflowX: "auto" }}>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: `140px repeat(${columns.length}, 1fr)`,
                    gap: 0.5,
                    minWidth: 460,
                }}
            >
                <Box />
                {columns.map((c, i) => (
                    <Typography
                        key={i}
                        sx={{ fontSize: 11, color: "text.secondary", textAlign: "center", pb: 0.5, fontWeight: 500 }}
                    >
                        {c}
                    </Typography>
                ))}

                {rows.map((row, ri) => (
                    <React.Fragment key={ri}>
                        <Typography sx={{ fontSize: 12.5, color: "text.primary", display: "flex", alignItems: "center" }}>
                            {row.label}
                        </Typography>
                        {row.values.map((v, ci) => {
                            const { bg, text } = cellColor(v, max);
                            return (
                                <Box
                                    key={ci}
                                    sx={{
                                        bgcolor: bg,
                                        borderRadius: 1,
                                        height: 40,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Typography sx={{ fontSize: 12.5, fontWeight: 500, color: text }}>
                                        {v}{suffix}
                                    </Typography>
                                </Box>
                            );
                        })}
                    </React.Fragment>
                ))}
            </Box>
        </Box>
    );
}

export default Heatmap;
